import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { api } from "../../common/setupApi";
import { getAvatarClub } from "../photos/photosSlice";

export const getChampionship = createAsyncThunk(
  "championship/get",
  async (_, { dispatch, rejectWithValue }) => {
    return api
      .get("competition-teams/")
      .then((res) => {
        const logoUrl = res.data.find((d) => d.app_team).logo;
        dispatch(getAvatarClub(logoUrl));
        return res.data;
      })
      .catch((err) => {
        return rejectWithValue(err.response?.data);
      });
  },
  {
    condition: (params, { getState }) => {
      if (params?.ignoreCondition) {
        return true;
      }
      // https://redux-toolkit.js.org/api/createAsyncThunk#canceling-before-execution
      const { status } = selectChampionship(getState());
      if (status === "fulfilled" || status === "pending") {
        // Already fetched or in progress, don't need to re-fetch
        return false;
      }
    },
  }
);

const initialState = {
  status: "idle",
  data: [],
  error: null,
};

const championshipSlice = createSlice({
  name: "championship",
  initialState,
  reducers: {
    add: (state, action) => {
      state.data.push(action.payload);
    },
    set: (state, action) => {
      state.data = state.data.map((d) =>
        d.id === action.payload.id ? action.payload : d
      );
    },
    delete: (state, action) => {
      state.data = state.data.filter((d) => d.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChampionship.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(getChampionship.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.data = action.payload;
      })
      .addCase(getChampionship.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase("auth/logout", () => initialState);
  },
});

export const championshipActions = championshipSlice.actions;

const _selectChampionship = (state) => state.championship;

export const selectChampionship = createSelector(
  [(state) => _selectChampionship(state)],
  (championship) => {
    const data = championship.data;
    const status = championship.status;
    const error = championship.error;
    const isLoading = status === "pending";
    return { data, status, error, isLoading };
  }
);

// memo ok
export const selectOpponents = createSelector(
  [(state) => selectChampionship(state).data],
  (data) => data.filter((d) => !d.app_team)
);

// memo ok
export const selectClub = createSelector(
  [(state) => selectChampionship(state).data],
  (data) => data.find((d) => d.app_team) || {}
);

export default championshipSlice.reducer;
